import React, { Component } from "react";
import { Auth } from "aws-amplify";
import { Button, CircularProgress, Typography } from '@material-ui/core';
import {states} from './loginConstants';
import {getLabels} from '../../constants/labels';


/** Handles the Sign Out part of the log in version */
export default class SignOut extends Component {
    state = {
        handling: false,
        username: ""
    }

    handleSignOut = event => {
        this.setState({handling: true});
        event.preventDefault();
        Auth.signOut({ global: true })
          .then(() => {
                this.setState({handling: false});
                this.props.switchComponent(states.SIGN_IN);
            })
          .catch(err => {
              console.log(err);
              this.setState({handling: false});
            });
    }

    componentDidMount() {
        Auth.currentAuthenticatedUser()
            .then(data => this.setState({username: data.username}));
    }

    render() {
        const {handling, username} = this.state;
        const labels = getLabels(this.props.language);
        const { classes } = this.props;
        
        return (
            <div style={{display: 'flex'}}>
                <Typography
                    style={{padding: '8px 2px 8px 8px', textTransform: 'none'}}>
                    {username}
                </Typography>
                <Button
                    size="medium"
                    onClick={this.handleSignOut}
                    disabled={handling}
                    style={{textTransform: 'none'}}
                    className={classes.activeButton}
                    endIcon={handling ? <CircularProgress size={20}/> : null}
                >
                    <b>{labels.signOut}</b>
                </Button>
            </div>
        )
    }
}